/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ErrorBoundary from "../../../ErrorBoundary";
import AggregateCard from "./AggregateCard";
import AggregateSentimentCard from "./AggregateSentimentCard";
import WidgetHeader from "../../layout2/sectionInsight/Widget/Header";

const AggregateChart = ({
  data,
  datatype,
  description,
  graph_type,
  type,
  dashboard,
  createTemplate,
  id,
  allData,
  filters,
}) => {
  //aggregate chart that includes aggregate card and sentiment aggregate cards

  const graphFilter = useSelector((state) => state.Welcome.graphDetail?.filter);

  let dashboardFilter = data?.[0]?.id == 6 || data?.[0]?.id == 7;
  let filter = dashboardFilter ? [1] : graphFilter ? graphFilter : filters;

  //aggregate cards id list
  const [idsList, setIdsList] = useState([]);

  //formatted data for aggregate chart accodring to id list
  const [data_map, setdataMap] = useState([]);

  useEffect(() => {
    let arr = [];
    let ids;
    if (filter?.length > 0) {
      ids = [6, 7, 10, 8, 9];
      ids?.forEach((e) => {
        arr?.push(
          data?.filter((e1) => {
            return e1.id == e;
          })[0]
        );
      });
    } else {
      datatype === "list" || data[data?.length - 1]?.id === "6"
        ? (ids = [1, 2, 4, 3, 6])
        : (ids = [1, 2, 4, 3, 5]);
      if (datatype === "int") {
        ids = [1, 2, 4, 3, 10];
      }

      data?.length > 0 &&
        ids?.forEach((e) => {
          arr?.push(
            data?.filter((e1) => {
              return e1?.id == e;
            })[0]
          );
        });
    }
    setIdsList(ids);
    setdataMap(arr);
  }, [data]);

  return (
      <div className="bg__white mb-15 aggregate_chart">
        {!dashboard && !createTemplate && data?.length > 0 && (
          <WidgetHeader
            id={id}
            graph={true}
            widget_name={allData?.widget_name}
            widget_description={allData?.widget_description}
            data={data}
            graph_type={graph_type}
            type={type}
          />
        )}
        {(data_map?.length > 0 || data) && (
          <div className="row ml-15 mr-0 pt-15">
            <div className="col-12 col-md-3 p-0">
              <ErrorBoundary>
                <AggregateCard
                  data={
                    data?.length === 0
                      ? null
                      : data_map?.length > 0 && data_map[0]
                  }
                  datatype={datatype}
                  filter={filter?.length}
                  id={idsList[0]}
                />
              </ErrorBoundary>

              <ErrorBoundary>
                <AggregateCard
                  data={
                    data?.length === 0
                      ? null
                      : data_map?.length > 0 && data_map[1]
                  }
                  datatype={datatype}
                  filter={filter?.length}
                  id={idsList[1]}
                />
              </ErrorBoundary>
            </div>
            <div className="col-12 col-md-6 p-0">
              <ErrorBoundary>
                <AggregateSentimentCard
                  data={data?.length === 0 ? null : data_map[2]}
                  filter={filter?.length}
                  description={description}
                />
              </ErrorBoundary>
            </div>
            <div className="col-12 col-md-3 p-0">
              <ErrorBoundary>
                <AggregateCard
                  data={
                    data?.length === 0
                      ? null
                      : data_map?.length > 0 && data_map[3]
                  }
                  datatype={datatype}
                  filter={filter?.length}
                  id={idsList[3]}
                />
              </ErrorBoundary>
              <ErrorBoundary>
                <AggregateCard
                  data={
                    data?.length === 0
                      ? null
                      : data_map?.length > 0 && data_map[4]
                  }
                  datatype={datatype}
                  filter={filter?.length}
                  id={idsList[4]}
                />
              </ErrorBoundary>
            </div>
          </div>
        )}
      </div>
  );
};

export default AggregateChart;
